(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[22874],{

/***/ 59303:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/[trade]/[quote]",
      function () {
        return __webpack_require__(76647);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52903);
/* harmony import */ var _hoa_pages_Category__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24038);
/* harmony import */ var _hoa_pages_ServiceRequest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26477);




var ServiceRequestPage = function(props) {
    if (props.isQuote) return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_hoa_pages_ServiceRequest__WEBPACK_IMPORTED_MODULE_1__/* .ServiceRequest */ .Q, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props));
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_hoa_pages_Category__WEBPACK_IMPORTED_MODULE_0__/* .Category */ .W, {
        lang: props.lang,
        rating: props.rating,
        tree: props.tree,
        highlight: props.highlight,
        categoryCityPage: props.categoryCityPage
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (ServiceRequestPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [64838,50594,40123,92510,15081,12047,80594,57539,24038,49774,92888,40179], function() { return __webpack_exec__(59303); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);